import { format } from 'date-fns'
import React from 'react'
import HeaderPdf from './pdfparts/header'

const DoctorRecommendations = ({ data }) => {
  return (
    <div className='main-container page9-container'>
      <HeaderPdf />
      <div className='pdf-content-container'>
        <div className='heading-seprator'>
          <h1>
            <span>DOCTOR RECOMMENDATION</span>
          </h1>
        </div>

        <div className='report-content'>
          <ol>
            {data?.map((recommendation) => (
              <li key={recommendation}>
                <div className='d-flex justify-content-between'>
                  <p>{recommendation.text}</p>
                  <p style={{ fontSize: 12, color: 'gray' }}>{recommendation.date}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <footer>
          <h6>12</h6>
        </footer>
      </div>
    </div>
  )
}

export default DoctorRecommendations
